module.exports = __webpack_public_path__ + "static/sport/game-4.8b67bc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/game-4.png
// module id = IuDr
// module chunks = 0